

window.currentUrl = window.location.href;

// In your main JS file
import "select2/dist/css/select2.css";
// ==== তোমার সব custom JS ====
import './helpers';
import './uploader';
import './common';
import './tasks';
import './settings';
import './order';
import './product';
import './inventory';
import './report';
import './shipping_auto_rate_combination';
import './employee';
import './assigned_employee';
import './carrier';
import './carrier_services';
import './location';
import './tracker';
import './pallet';
import './carrierTag';
import './scanner';


